export const FETCH_CATEGORIES_REQUEST = 'FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';

export const FETCH_GOODS_REQUEST = 'FETCH_GOODS_REQUEST';
export const FETCH_GOODS_SUCCESS = 'FETCH_GOODS_SUCCESS';
export const FETCH_GOODS_FAILURE = 'FETCH_GOODS_FAILURE';

export const UPDATE_GOOD_REQUEST = 'UPDATE_GOOD_REQUEST';
export const UPDATE_GOOD_SUCCESS = 'UPDATE_GOOD_SUCCESS';
export const UPDATE_GOOD_FAILURE = 'UPDATE_GOOD_FAILURE';

export const DELETE_GOOD_REQUEST = 'DELETE_GOOD_REQUEST';
export const DELETE_GOOD_SUCCESS = 'DELETE_GOOD_SUCCESS';
export const DELETE_GOOD_FAILURE = 'DELETE_GOOD_FAILURE';

export const ADD_GOOD_REQUEST = 'ADD_GOOD_REQUEST';
export const ADD_GOOD_SUCCESS = 'ADD_GOOD_SUCCESS';
export const ADD_GOOD_FAILURE = 'ADD_GOOD_FAILURE';